import React, { Component } from "react";
import { connect } from "react-redux";

//Pages
import UserAccountPage from "./user_dashboard/UserAccountPage";
import ClientAccountPage from "./client_dashboard/ClientAccountPage";
import DefaultAccountPage from "./default_dashboard/DefaultAccountPage";

function mapStateToProps(state) {
  return {
    role: state.user.currentUser.role
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

class AccountRouter extends Component {
  render() {
    const { role } = this.props;
    return (
      <div>
        {role === "client" ? (
          <ClientAccountPage {...this.props} />
        ) : role === "user" ? (
          <UserAccountPage {...this.props} />
        ) : (
          <DefaultAccountPage {...this.props} />
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountRouter);



// WEBPACK FOOTER //
// ./src/pages/AccountRouter.js